export function testMode() {
  /**
   * Returns true if in test mode, false otherwise.
   */
  return window.__karma__ !== undefined;
}
